import { render, staticRenderFns } from "./serverMenu.vue?vue&type=template&id=42fae4c4&scoped=true&"
import script from "./serverMenu.vue?vue&type=script&lang=js&"
export * from "./serverMenu.vue?vue&type=script&lang=js&"
import style0 from "./serverMenu.vue?vue&type=style&index=0&id=42fae4c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fae4c4",
  null
  
)

export default component.exports